module.exports = __webpack_public_path__ + "static/img/184.77c1bdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/184.jpg
// module id = hXjv
// module chunks = 0